import { render, staticRenderFns } from "./TipoRecomendacaoList.vue?vue&type=template&id=0295ac22&scoped=true"
import script from "./TipoRecomendacaoList.vue?vue&type=script&lang=js"
export * from "./TipoRecomendacaoList.vue?vue&type=script&lang=js"
import style0 from "./TipoRecomendacaoList.vue?vue&type=style&index=0&id=0295ac22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0295ac22",
  null
  
)

export default component.exports